import WarnIcon from "@/components/icons/WarnIcon";
import StepTitles from "@/components/StepTitles";
import Branch from "@/components/Branch";
import StepFooter from "@/components/StepFooter";
import {useEffect} from "react";
import {dataLayerPush, oxford} from "@/helpers";
import {useAppState} from "@/store";

export default function Inestimable() {

    const {state, setState} = useAppState()

    const content = window.ein?.content?.step_5_1 || {}
    const branches = window.ein?.content?.locations || []

    const {title, secondary_title, tertiary_title} = content

    useEffect(() => {

        const reasons = Object.values(state.inestimable).filter(i => !!i).map(i => i.map(r => r.humanReason)).flat(1)

        setState((s) => {
            s.inestimable_reason = oxford(reasons, 'and', false) || null
        })

        dataLayerPush('book-inestimable-view', {
            ['book-assigned-branch']: state.branch?.name || null,
            ['book-inestimable-reasons']: reasons,
            ['book-inestimable-email']: state.contact.email,
            ['book-inestimable-first-name']: state.contact.first_name,
            ['book-inestimable-last-name']: state.contact.last_name,
            ['book-inestimable-phone']: state.contact.phone,
        }).then()

    }, [])


    return (
        <div className={"grid grid-cols-4 lg:grid-cols-12 gap-x-[20px] lg:gap-x-[32px] gap-y-[40px]"}>
            <div className="col-span-4 lg:col-span-12 flex flex-col items-center text-center">
                <WarnIcon className={'size-[80px] mb-[16px]'}/>
                <StepTitles title={title} secondaryTitle={secondary_title} tertiaryTitle={tertiary_title}/>
            </div>
            <div className={"col-span-4 lg:col-span-12 flex gap-[20px] md:gap-[32px] flex-wrap justify-center [&>*]:w-[calc((100%-20px)/2)] md:[&>*]:w-[calc((100%-64px)/3)] xl:[&>*]:w-[calc((100%-96px)/4)]"}>
                {branches.map((b, i) => (b.phone && b.email) && <Branch branch={b} key={i} />)}
            </div>
            <div className="col-span-4 lg:col-span-12">
                <StepFooter/>
            </div>
        </div>
    )
}
